import React from 'react';
import { Button, Flex } from '@opendoor/bricks/core';
import { getHubSSVAUploadRoute } from 'shared/helpers/routes';
import { OdProtosWebData_RecordedFeature as RecordedFeature } from '__generated__/globalTypes';
import { useHistory, generatePath } from 'react-router-dom';
import { useSubmitSSVAByRecordedFeature } from 'sellDirect/graphql/useSubmitSSVAByRecordedFeature';
import { useUpdateVirtualAssessmentRecordings } from 'sellDirect/graphql/useUpdateVirtualAssessmentRecordings';
import { useQualificationContext } from 'shared/helpers/QualificationContext';

interface TaskCtasProps {
  recordedFeature: RecordedFeature;
  submissionCompleted?: boolean;
  loading?: boolean;
}

/**
 * Renders the CTAs for SSVA tasks.
 * component-test-check-ignore
 * storybook-check-ignore
 */
export const TaskCtas: React.FC<TaskCtasProps> = ({
  recordedFeature,
  loading,
  submissionCompleted,
}) => {
  const { submitSSVAByRecordedFeature, loading: submittingSSVARecording } =
    useSubmitSSVAByRecordedFeature();
  const { addressUUID } = useQualificationContext();
  const { loading: updatingSSVARecordings } = useUpdateVirtualAssessmentRecordings();

  const history = useHistory();
  const updatingOrSubmittingSSVA = updatingSSVARecordings || submittingSSVARecording;
  const uploadOrSubmitButtonDisabled =
    loading || updatingSSVARecordings || submissionCompleted || submittingSSVARecording;

  return (
    <Flex width="100%" justifyContent="space-between" alignItems="center" flexDirection="column">
      <Button
        mt={9}
        onClick={() => submitSSVAByRecordedFeature(recordedFeature)}
        disabled={uploadOrSubmitButtonDisabled}
        analyticsName={`submit-${recordedFeature.toLowerCase()}`}
        loading={updatingOrSubmittingSSVA}
        aria-label={`Submit video for ${recordedFeature}`}
      >
        Submit
      </Button>
      <Button
        mt={5}
        onClick={() => history.push(generatePath(getHubSSVAUploadRoute(), { addressUUID }))}
        disabled={uploadOrSubmitButtonDisabled}
        variant="secondary"
        analyticsName={`save-${recordedFeature.toLowerCase()}`}
        loading={updatingOrSubmittingSSVA}
        aria-label={null}
      >
        Save Progress and Close
      </Button>
    </Flex>
  );
};
